import { getCurrentOrUpcomingSchoolHoliday } from '../../../common/helpers/schoolHolidays';
import api from '../../../legacy/api';
import { SchoolHolidayTerm, SessionPolicy } from '../../../legacy/types';
import { canPauseEnrolment } from '../helpers';
import useCanPauseEarly from './useCanPauseEarly';

/* For Pause Enrolment entry points */
// #TODO - add tests
const useCanPauseEnrolment = (enrolmentSfid: string, enrolmentPolicy: SessionPolicy) => {
  const { data: termsAndHolidays } = api.schoolTerm.holidays.useQuery();
  const currentOrUpcomingHoliday = getCurrentOrUpcomingSchoolHoliday((termsAndHolidays as SchoolHolidayTerm[]) || []);
  const { canPauseEarly } = useCanPauseEarly(enrolmentPolicy, currentOrUpcomingHoliday);
  const { data: salesforceCases } = api.salesforceCase.all.useQuery(enrolmentSfid, { enabled: !!enrolmentSfid });
  const hasTakenSummerOffer = !!salesforceCases && salesforceCases?.cases?.length > 0;
  const enrolmentCanBePaused =
    enrolmentPolicy?.pause?.isAllowed &&
    (canPauseEnrolment(enrolmentPolicy, currentOrUpcomingHoliday) || canPauseEarly);

  return enrolmentCanBePaused && !hasTakenSummerOffer;
};

export default useCanPauseEnrolment;
